import { HttpClient } from '@angular/common/http';
import { CacheService } from '../cache';
import { ResourceService } from './resource';
import { Property } from '../../models/property';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PropertyService extends ResourceService<Property> {
  
  /**
    * @constructor 
    * Creates an instance of the PropertyService 
    *
    * @param {HttpClient} http Injected instance of HttpClient
    * @param {CacheService} cache Injected instance of CacheService
  */

  constructor(
    protected http: HttpClient,
    protected cache: CacheService
  ) {
    super(http, cache, 'properties');
  }

  /**
    * Sends a GET request to the /properties/types endpoint
    * @remarks
    * to get types of properties e.g 'Detached', 'Flat'
    *
    * @param {boolean} mapped Optional flag that determines what is been returned
    * @returns {Observable} Returns an observable of any with a server-side representations of the matching resources 
  */
  getPropertiesTypes(mapped?: boolean) {
    return this.http.get<any>(`${this.endpoint}/types`).pipe(
      map((res: any) => {
        if (mapped === true) {
          return res.data.property_types.reduce((map: any, type: any) => {
            return map[type.id] = type.name
          }, {});
        } else {
          return res.data.property_types
        }
      })
    )
  }

  /*
  recommendedProperties(queryOptions?: HttpParams, raw?: boolean) {
    return this.http.get<any>(`${this.endpoint}/recommended`, { params: queryOptions })
      .pipe(map((resp: any) => {
        resp.data.properties = this.convertData(resp.data.properties)
        if (!raw) {
          return resp.data.properties;
        }
        return resp;
      }))
  }

  latestProperties(queryOptions?: HttpParams, raw?: boolean) {
    return this.http.get<any>(`${this.endpoint}/listings`, { params: queryOptions })
      .pipe(map((resp: any) => {
        resp.data.properties = this.convertData(resp.data.properties)
        if (!raw) {
          return resp.data.properties;
        }
        return resp;
      }))
  }
  */

  /**
    * Sends a PUT  request to the /properties/:id/visibility endpoint
    * @remarks
    * to publish or unpublish a property
    *
    * @param {object} item flag indicating if publishing the
    * property is true or false.
    * Id is the unique identifier for the selected property 
    * @returns {Observable} Returns an observable with a server-side representations of the matching resources 
  */
  publish(item: { id: string, published: boolean }) {
    const { published } = item;
    return this.http.put(`${this.endpoint}/${item.id}/visibility`, { published }).pipe(map(resp => {
      this.cache.remove(`${this.endpoint}/${item.id}`);
      this.cache.remove(`${this.endpoint}`);
      return resp;
    }))
  }

  /**
    * Sends a PUT request to the /properties/visibility endpoint
    * @remarks
    * to publish or unpublish multiple properties
    *
    * @param {object} data flag indicating if publishing the
    * property is true or false.
    * Ids is the unique identifiers for the selected properties 
    * @returns {Observable} Returns an observable with a server-side representations of the matching resources 
  */
   bulk_publish(data: { ids: string[], published: boolean }): Observable<any> {
    return this.http.put(`${this.endpoint}/visibility`, data).pipe(map(resp => {
      data.ids.forEach(id => this.cache.remove(`${this.endpoint}/${id}`));  
      this.cache.remove(`${this.endpoint}`);
      return resp;
    }))
  }

  /**
    * Sends a POST request to the /properties/import endpoint
    * @remarks
    * to upload properties in bulk
    *
    * @param {object} data  
    * @returns {Observable} Returns an observable with a server-side representations of the matching resources 
  */
  import(data: any): Observable<any> {
    return this.http.post<any>(`${this.endpoint}/import`, data)
      .pipe(map((resp: any) => resp.data));
  }

}
